import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  FormControlLabel,
  Button,
  Slide,
  Card,
  CardContent,
  DialogActions,
  Typography,
  Drawer,
  Box,
  Stack,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { notification } from 'antd';
import { getToken, getAclMenu } from '../../../utils/common';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
export default function DialogCalendar(props) {
  const { t } = useTranslation();

  const { open, data, handleClose, date, refresh } = props;
  const [acl] = useState(getAclMenu('calendar'));
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const fetchInfo = (url) =>
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ id: selectedItems }),
    })
      .then((res) => res.json())
      .then((d) => {
        notification.success({
          message: 'Success',
          description: t('CalendarPrompt.5'),
          placement: 'top',
          duration: 5,
        });
        refresh();
        handleClose();
      });
  const handleDeleteSelected = () => {
    fetchInfo(`${globalThis.REACT_APP_API_PURE}calendar/deletecalendar`);
  };
  const handleCheckboxChange = (itemId) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(itemId)) {
        return prevSelected.filter((id) => id !== itemId);
      }
      return [...prevSelected, itemId];
    });
  };
  const [selectedItems, setSelectedItems] = useState([]);
  const calendarList = data.filter((item, index, self) => self.findIndex((t) => t.id === item.id) === index);

  const body = (
    <>
      <DialogTitle className="text-left">
        <Typography variant="h6" className="font-semibold text-gray-800">
          {t('CalendarPrompt.1')} {date}
        </Typography>
        <Typography variant="body2" className="text-gray-500">
          {t('CalendarPrompt.subtitle', { defaultValue: 'Choose the schedule you want to manage' })}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {calendarList.map((item) => (
            <Card key={item.id} variant="outlined" className="rounded-2xl border border-slate-200 shadow-sm">
              <CardContent className="flex flex-col gap-2">
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!acl?.delete}
                      checked={selectedItems.includes(item.id)}
                      onChange={() => handleCheckboxChange(item.id)}
                      color="primary"
                    />
                  }
                  label={
                    <Stack spacing={0.5}>
                      <Typography variant="subtitle2" className="font-semibold text-slate-800">
                        {item.title}
                      </Typography>
                      <Typography variant="caption" className="text-gray-500">
                        {item.schedule}{' '}
                        {item.time_end
                          ? new Date(item.time_end).toLocaleString('en-ID', { timeZone: 'Asia/Jakarta' })
                          : new Date(item.time_start).toLocaleString('en-ID', { timeZone: 'Asia/Jakarta' })}
                      </Typography>
                    </Stack>
                  }
                />
              </CardContent>
            </Card>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions className="px-6 pb-6">
        <Button variant="outlined" onClick={handleClose} className="text-red-500 border-red-200">
          {!acl?.delete ? t('CalendarPrompt.2') : t('CalendarPrompt.3')}
        </Button>

        {acl?.delete && (
          <Button
            className="bg-cyan-500 text-white hover:bg-cyan-600"
            onClick={handleDeleteSelected}
            disabled={!selectedItems.length}
          >
            {t('CalendarPrompt.4')}
          </Button>
        )}
      </DialogActions>
    </>
  );

  if (isMobile) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={handleClose}
        PaperProps={{ className: 'rounded-t-3xl', sx: { maxHeight: '90vh' } }}
      >
        <Box className="flex flex-col gap-2">{body}</Box>
      </Drawer>
    );
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      aria-describedby="dialog-calendar"
    >
      {body}
    </Dialog>
  );
}

DialogCalendar.propTypes = {
  open: PropTypes.bool,
  data: PropTypes.array,
  handleClose: PropTypes.func,
  date: PropTypes.string,
  refresh: PropTypes.func,
};
